<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="12" xs="12" sm="10" md="6" class="pb-0">
                <p class="headline font-weight-light">Gerät</p>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
//import Vue from 'vue'
export default {
  name: 'Geraetegruppen',
  components: {},
  data () {
    return {
        FormMachine: {
            name: '',
            screenNumber: '',
            owner: '',
            playlist: '',
            phone: '',
            create: '',
            changed: ''
        }
    }
  },
  methods: {
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
